export function Spinner({ size = 18, label }: { size?: number; label?: string }) {
  return (
    <span
      className="nyk-ui-spinner"
      role="status"
      aria-label={label ?? 'Loading'}
      style={{ width: size, height: size }}
    />
  );
}
